import interfaceAjax from '@/libs/InterfaceAjax';

export default {

    all(data) {
        return interfaceAjax({
            url: '/admin/fence/all',
            data:data
        });
    },
    save(data) {
        return interfaceAjax({
            url: '/admin/fence/save',
            data:data
        });
    },
    delete(id) {
        return interfaceAjax({
            url: '/admin/fence/delete',
            data:{id:id}
        });
    },
    alertAll(params, data) {
        return interfaceAjax({
            url: '/admin/fenceAlert/list',
            params,
            data
        });
    },
    alertSta() {
        return interfaceAjax({
            url: '/admin/fenceAlert/sta',
        });
    },
    alertProcess(id, status) {
        return interfaceAjax({
            url: '/admin/fenceAlert/process',
            data:{id, status}
        });
    }

}
